import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';
import { VALUE_FIRST_GOALS } from '../../services/value-first-onboarding.types';

@Component({
  selector: 'vf-welcome-step',
  templateUrl: './welcome-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfWelcomeStep {
  readonly onboarding = inject(ValueFirstOnboardingService);
  readonly goals = VALUE_FIRST_GOALS;

  selected(goal: string): boolean {
    return this.onboarding.draft().goals.includes(goal);
  }

  toggle(goal: string): void {
    this.onboarding.toggleGoal(goal);
  }

  quickBrief(): void {
    void this.onboarding.finish('quick_brief');
  }

  skip(): void {
    void this.onboarding.finish('skip');
  }
}
